import { ITypeSite } from '@/app/shared/store/layout.store'

export const getColorTextSite = (slug: ITypeSite) => {
  // return `text-${slug}`
  switch (slug) {
    case 'offline': {
      return 'text-success'
    }
    case 'kids': {
      return 'text-success'
    }
    default: {
      return 'text-secondary'
    }
  }
}

export const getColorBgSite = (slug: ITypeSite) => {
  // return `bg-${slug}`
  switch (slug) {
    case 'offline': {
      return 'bg-success'
    }
    case 'kids': {
      return 'bg-success'
    }
    default: {
      return 'bg-secondary'
    }
  }
}

export const getColorHoverBgSite = (slug: ITypeSite) => {
  // return `hover:bg-${slug}`
  switch (slug) {
    case 'offline': {
      return 'hover:bg-success'
    }
    case 'kids': {
      return 'hover:bg-success'
    }
    default: {
      return 'hover:bg-secondary'
    }
  }
}

export const getColorBorderSite = (slug: ITypeSite) => {
  // return `border-${slug}`
  switch (slug) {
    case 'offline': {
      return 'border-success'
    }
    case 'kids': {
      return 'border-success'
    }
    default: {
      return 'border-secondary'
    }
  }
}

export const getColorBtnSite = (slug: ITypeSite): 'secondary' | 'success' => {
  switch (slug) {
    case 'offline': {
      return 'success'
    }
    case 'kids': {
      return 'success'
    }
    default: {
      return 'secondary'
    }
  }
}

export const getColorSite = (
  slug?: string | ITypeSite,
  func?: (slug: string) => string,
): string => {
  switch (slug) {
    case 'offline': {
      return '#28B4FA'
    }
    case 'kids': {
      return '#28B4FA'
    }
    default: {
      return func ? func('text-secondary') : ''
    }
  }
}

export const styles = (slug?: string) => {
  return {
    base: 'bg-content1-200 py-[20px] px-[30px] extraMobile:py-[50px] m-0 laptop:m-1 max-w-full laptop:max-w-3xl',
    body: 'p-0',
    wrapper: 'z-[100000000]',
    backdrop: 'bg-content1-200 bg-opacity-50',
    closeButton: `flex p-1 items-center justify-center hover:bg-${slug} border-2 border-content1-400 bg-${slug} w-[34px] h-[34px] [&>svg]:w-full [&>svg]:h-full [&>svg]:text-white [&>svg]:stroke-3 active:bg-${slug} top-[24px] right-[24px]`,
  }
}
